import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api, { errMsg } from '../lib/api';
import { PageHead } from './components';
import { gbp } from '../lib/shop';

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/admin/analytics/overview').then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!d) return <div className="h-40 bg-white animate-pulse border hairline" />;

  const stats = [
    ['Product views', d.product_views], ['Searches', d.searches], ['Zero-result searches', d.zero_searches],
    ['Basket additions', d.basket_adds], ['Checkout starts', d.checkout_starts],
    ['Interest registrations', d.interest_registrations], ['Paid orders', d.sales], ['Revenue', gbp(d.revenue)],
  ];

  const List = ({ title, rows, left, right, testid }) => (
    <div className="border hairline bg-white p-5">
      <p className="font-display font-bold uppercase text-lg mb-3">{title}</p>
      <div className="space-y-1.5" data-testid={testid}>
        {rows.length === 0 && <p className="text-sm text-[#8A8F95]">No data yet</p>}
        {rows.map((r, i) => (
          <div key={i} className="flex justify-between text-sm border-b hairline pb-1.5 last:border-0">
            <span className="truncate pr-3">{left(r)}</span>
            <span className="font-mono2 text-xs text-[#8A8F95] whitespace-nowrap">{right(r)}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div data-testid="admin-analytics">
      <PageHead title="Analytics" sub="Privacy-respecting, anonymised store analytics. No sensitive profiling." />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
        {stats.map(([l, v]) => (
          <div key={l} className="bg-white border hairline p-4">
            <p className="font-mono2 text-[9px] uppercase tracking-[0.18em] text-[#8A8F95]">{l}</p>
            <p className="font-display font-black text-2xl mt-1">{v}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <List title="Most viewed products" rows={d.top_viewed} left={(r) => `${r.name} ${r.strength || ''}`} right={(r) => `${r.views || 0} views`} testid="analytics-top-products" />
        <List title="Top searches" rows={d.top_searches} left={(r) => r.query} right={(r) => `×${r.count}`} testid="analytics-top-searches" />
        <List title="Zero-result searches (demand gaps)" rows={d.zero_result_searches} left={(r) => r.query} right={(r) => `×${r.count}`} testid="analytics-zero-searches" />
        <List title="Interest by product" rows={d.interest_by_product} left={(r) => r.product} right={(r) => `×${r.count}`} testid="analytics-interest" />
      </div>
    </div>
  );
}
